import isotipoUrl from '../../assets/hotseat/wargos-isotipo.svg';
import machineUrl from '../../assets/images/slot-machine.svg';
import { couponLabel, winnerName } from './raffleResult';
import { parseDateTime } from '../../util/dateUtils';

let artworkPromise;
function loadImage(url) {
  return new Promise(resolve => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => resolve(null);
    image.src = url;
  });
}

// Use the same vector assets as the rest of the app; only the permitted
// monochrome treatment changes. Keep each image's original proportions.
export function drawTintedImage(context, image, x, y, width, height, color) {
  if (!image) return;
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(width);canvas.height = Math.ceil(height);
  const c = canvas.getContext('2d');
  const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
  const w = image.naturalWidth * scale, h = image.naturalHeight * scale;
  c.drawImage(image, (width - w) / 2, (height - h) / 2, w, h);
  c.globalCompositeOperation = 'source-in';c.fillStyle = color;c.fillRect(0, 0, width, height);
  context.drawImage(canvas, x, y);
}

export function loadRaffleArtwork() {
  if (!artworkPromise) {
    const fonts = document.fonts
      ? Promise.all([600, 700, 800].map(weight => document.fonts.load(`${weight} 40px "Open Sans"`))).catch(() => {})
      : Promise.resolve();
    artworkPromise = Promise.all([loadImage(isotipoUrl), loadImage(machineUrl), fonts])
      .then(([isotipo, machine]) => ({ isotipo, machine }));
  }
  return artworkPromise;
}

export function fitCanvasText(c, text, maxWidth, size, weight = 800) {
  c.font = `${weight} ${size}px "Open Sans", sans-serif`;
  while (c.measureText(text).width > maxWidth && size > 12) {
    size -= 1;c.font = `${weight} ${size}px "Open Sans", sans-serif`;
  }
  return size;
}

function drawName(c, text, width) {
  c.font = '800 86px "Open Sans", sans-serif';
  let lines = [text];
  if (c.measureText(text).width > width) {
    const words = text.split(/\s+/);
    let best = Infinity;
    for (let i = 1; i < words.length; i++) {
      const pair = [words.slice(0, i).join(' '), words.slice(i).join(' ')];
      const length = Math.max(...pair.map(line => c.measureText(line).width));
      if (length < best) { best = length;lines = pair; }
    }
  }
  const longest = lines.reduce((a, b) => c.measureText(a).width > c.measureText(b).width ? a : b);
  const size = fitCanvasText(c, longest, width, 86);
  lines.forEach((line, i) => c.fillText(line, 700, lines.length === 1 ? 234 : 190 + i * (size + 12)));
}

// Paths from MdLocalPlay and MdOutlineAccessTime, also used by CardWinner.
const ticketPath = 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z';
const clockPath = 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z';
function icon(c, path, x, y, size) {
  c.save();c.translate(x, y);c.scale(size / 24, size / 24);c.fill(new Path2D(path));c.restore();
}

export const TICKET_WIDTH = 1400;
export const TICKET_HEIGHT = 800;
const SHIFT = -60;   // sin el título «¡FELICIDADES!» (ahora va arriba, fuera del cupón) el contenido sube

export function paintWinnerTicket(canvas, winner, artwork) {
  const c = canvas.getContext('2d'), w = TICKET_WIDTH, h = TICKET_HEIGHT;
  c.clearRect(0, 0, w, h);c.fillStyle = '#fff4d9';c.fillRect(0, 0, w, h);
  c.strokeStyle = '#a17c3d';c.lineWidth = 5;c.strokeRect(24, 24, w - 48, h - 48);
  c.strokeStyle = '#cfb884';c.lineWidth = 2;c.strokeRect(38, 38, w - 76, h - 76);
  c.textAlign = 'center';c.save();c.translate(0, SHIFT);
  c.fillStyle = '#30251b';drawName(c, (winnerName(winner) || 'CLIENTE ANÓNIMO').toUpperCase(), w - 160);
  if (winner.document) {
    const document = `${winner.documentTypeName || 'DOCUMENTO'}: ${winner.document}`.toUpperCase();
    c.fillStyle = '#655033';fitCanvasText(c, document, w - 160, 46, 600);c.fillText(document, w / 2, 336);
  }
  c.strokeStyle = '#c6a66b';c.beginPath();c.moveTo(92, 385);c.lineTo(w - 92, 385);c.stroke();
  c.fillStyle = '#805e26';c.font = '700 32px "Open Sans", sans-serif';
  const couponText = 'CUPÓN N.º', couponX = (w - (56 + c.measureText(couponText).width)) / 2;   // icono + texto centrados
  icon(c, ticketPath, couponX, 414, 40);c.textAlign = 'left';c.fillText(couponText, couponX + 56, 447);c.textAlign = 'center';
  const label = couponLabel(winner);c.fillStyle = '#30251b';fitCanvasText(c, label, w - 170, 124);
  c.fillText(label, w / 2, 581);

  const date = parseDateTime(winner.couponCreatedAt);
  const details = [];
  if (winner.machine != null && String(winner.machine).trim()) details.push({ label: 'MÁQUINA', value: String(winner.machine), machine: true });
  if (date) details.push({ label: 'FECHA Y HORA DE EMISIÓN', value: date.setLocale('en').toFormat('dd/MM/yyyy  ·  hh:mm a').toUpperCase() });
  if (!details.length) { c.restore();return; }
  c.strokeStyle = '#bca16b';c.setLineDash([6, 8]);c.beginPath();c.moveTo(92, 638);c.lineTo(w - 92, 638);c.stroke();c.setLineDash([]);
  // Los dos datos comparten tamaño de letra y el conjunto se centra en el cupón.
  const GAP = 90, ICON = 80, room = w - 184;
  const blockWidths = (vs, ls) => details.map(detail => {
    c.font = `700 ${ls}px "Open Sans", sans-serif`;const label = c.measureText(detail.label).width;
    c.font = `700 ${vs}px "Open Sans", sans-serif`;return ICON + Math.max(label, c.measureText(detail.value).width);
  });
  let valueSize = 38, labelSize = 27, widths = blockWidths(valueSize, labelSize);
  while (widths.reduce((a, b) => a + b, 0) + GAP * (details.length - 1) > room && valueSize > 20) {
    valueSize -= 1;labelSize = Math.round(valueSize * 0.71);widths = blockWidths(valueSize, labelSize);
  }
  let x = (w - (widths.reduce((a, b) => a + b, 0) + GAP * (details.length - 1))) / 2;
  details.forEach((detail, i) => {
    c.fillStyle = '#896728';
    if (detail.machine) drawTintedImage(c, artwork.machine, x, 710, 60, 60, '#896728');
    else icon(c, clockPath, x, 710, 60);
    c.textAlign = 'left';
    c.font = `700 ${labelSize}px "Open Sans", sans-serif`;c.fillStyle = '#7e633a';c.fillText(detail.label, x + ICON, 720);
    c.font = `700 ${valueSize}px "Open Sans", sans-serif`;c.fillStyle = '#30251b';c.fillText(detail.value, x + ICON, 775);
    x += widths[i] + GAP;
  });
  c.restore();
}
